import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { server, Auth } from "redux-server-connection";
import urls from "../../reducers/urls";

import Render from "./Render";

class DesafiosPreguntas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answers: [],
      currentQuestion: 0,
      selectedAnswer: null,
      answered: false,
      answerIsCorrect: false,
      points: null,
      showDialogoSalir: false
    };
    this.bindings = {
      selectAnswer: this.selectAnswer.bind(this),
      checkAnswer: this.checkAnswer.bind(this),
      answer: this.answer.bind(this),
      onBack: this.onBack.bind(this),
      onAccept: this.onAccept.bind(this),
      onClose: this.onClose.bind(this)
    };
  }

  componentWillMount() {
    if (typeof window !== "undefined" && !this.props.training) {
      this.props.getTraining();
    }
  }

  onAccept() {
    this.props.history.push("/capacitaciones");
  }

  onBack() {
    this.setState({ showDialogoSalir: true });
  }

  onClose() {
    this.setState({ showDialogoSalir: false });
  }

  selectAnswer(answer) {
    if (!this.state.answered) {
      this.setState(state => {
        state.selectedAnswer = answer;
        state.answered = false;
        return state;
      });
    }
  }

  checkAnswer() {
    if (!this.state.selectedAnswer) {
      this.setState(state => {
        state.answered = false;
        state.answerIsCorrect = false;
        return state;
      });
    }
    
    this.setState(state => {
      state.answered = true;
      state.answerIsCorrect = this.state.selectedAnswer.valid;
      return state;
    });
  }

  answer() {
    if (!this.state.selectedAnswer) {
      return;
    }
    if (!this.state.answered) {
      return;
    }

    if (this.state.currentQuestion === this.props.training.questions.length - 1) {
      let answers = this.state.answers;

      if (this.props.training.questions.length > this.state.answers.length) {
        answers.push(this.state.selectedAnswer);
      }

      fetch(urls.trainings.answer(this.props.training.id), {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ answers }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          if (response.status !== 200) {
            alert("Ocurrio un error");
            return;
          }

          return response.json();
        })
        .then(json => {
          const user = Auth.getUser();
          user.points += parseInt(json.result.points, 10);
          user.monthlyPoints += parseInt(json.result.points, 10);
          user.unpaidPoints += parseInt(json.result.points, 10);
          this.setState({ points: json.result.points,
                          correctAnswers: json.result.correctAnswers,
                          totalQuestions: json.result.totalQuestions});
          Auth.setUser(user, true);
        });
      return;
    }

    this.setState(state => {
      state.answers.push(state.selectedAnswer);
      state.selectedAnswer = null;
      state.answered = false;
      state.answerIsCorrect = false;
      state.currentQuestion = state.currentQuestion + 1;
      return state;
    });
  }

  render() {
    return <Render {...this.props} {...this.state} {...this.bindings} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return { training: state.trainings.elements[ownProps.match.params.id] };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getTraining: () =>
      dispatch(
        server.get(
          urls.trainings.single(ownProps.match.params.id),
          "ELEMENT_TRAININGS"
        )
      )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DesafiosPreguntas));



// WEBPACK FOOTER //
// ./src/pages/DesafiosPreguntas/index.js